import styled from 'styled-components';

export const TagStatusSt = styled.div`
  background: ${(props) => (props.status == 1 ? '#D6FFF0' : '#000')};
  color: ${(props) => (props.status == 1 ? '#389D79' : '#000')};
  width: 100px;
  border-radius: 50px;
  padding: 2px 10px;
`;
